import { TitleSkeletonContainer } from "./styles";

const TitleSkeleton = () => {
  return (
    <TitleSkeletonContainer className="bnly-title-skeleton-container">
      <div className="bnly-title-skeleton" />
      <div className="bnly-title-paragraph-skeleton" />
    </TitleSkeletonContainer>
  );
};

export default TitleSkeleton;
